<template>
  <tr>
    <td v-if="environment.user_is_admin" class="text-center">
      <router-link v-if="environment.user_is_admin" :to="editMenuUrl">
        <span data-bs-toggle="tooltip" data-bs-placement="top" title="Editar datos del menú"><img src="../../assets/pencil.svg" alt="Editar datos del menú"></span>
      </router-link>
    </td>
    <td>
      <p data-bs-toggle="tooltip" data-bs-placement="top" title="Título del menú" class="text-left">{{ menu.title_translation.es }}</p>
    </td>
    <td>
      <p data-bs-toggle="tooltip" data-bs-placement="top" title="Nombre del menú" class="text-left">{{ menu.name }}</p>
    </td>
    <td>
      <p data-bs-toggle="tooltip" data-bs-placement="top" title="Descripción del menú" class="text-left">{{ menu.description }}</p>
    </td>
    <td>
      <p data-bs-toggle="tooltip" data-bs-placement="top" title="Posiciòn del menú" class="text-left">{{ menu.position }}</p>
    </td>
    <td>
      <p data-bs-toggle="tooltip" data-bs-placement="top" title="Clase CSS del menú" class="text-left">{{ menu.css_class }}</p>
    </td>
    <td><p class="text-left"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="activeHelp"><span v-if="menu.is_disabled == '0'">&#10004;</span></span></p></td>
    <td><p title="Tipo del menú" class="text-left">{{ menu.type }}</p></td>
    <td><p class="text-left"><span v-if="menu.draft_status == '1'">&#10004;</span></p></td>
    <td>
      <router-link :to="listMenuItemsUrl">
        <span data-bs-toggle="tooltip" data-bs-placement="top" title="Editar elementos del menú"><img src="../../assets/pencil.svg" alt="Editar elementos del menú"></span>
      </router-link>
    </td>
    <td v-if="environment.user_is_admin" class="text-center">
      <a href="#" onclick="return false;" >
        <span data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar menú" @click="deleteMenu(menu.id)"><img src="../../assets/trashcan.svg" alt="Eliminar menú"></span>
      </a>
    </td>
  </tr>
</template>

<script>
import HelpTexts from '@/utils/HelpTexts.js'

export default {
  name: 'menus-table-row',
  emits: ["delete_menu"],
  props: {
    menu: {
      type: Object,
      default: {}
    },
    environment: {
      type: Object,
      default: {}
    }
  },
  computed : {
    editMenuUrl: function () {
      return "/res/mvc.php/web_menus_tool/editMenu/" + this.menu.id;
    },
    listMenuItemsUrl: function () {
      return "/res/mvc.php/web_menus_tool/listMenuItems/" + this.menu.id;
    },
    activeHelp: function () {
      return HelpTexts.getMenuActiveText();
    },
  },
  methods : {
    deleteMenu (menuId) {
      this.$emit('delete_menu', menuId);
    }
  }
}
</script>
